import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { bm_date, buildFileFromChunks, cycleArray, drawQty, getEnumLabel, kbdEvent, requestClerkCode, showConfirm, updateOrdering } from "../utils/Utils";
import { ENUMS } from "../utils/Enums";
import Float from "../ui/Float";
import Label from "../ui/Label";
import Space from "../ui/Space";
import Input from "../ui/Input";
import Tags from "../ui/Tags";
import ReportFilter from "./ReportFilter";
import { ROUTES } from "../utils/Routes";
import Select from "../ui/Select";
import ReportColumns from "./ReportColumns";
import SelectInput from "../ui/SelectInput";
import Divider from "../ui/Divider";
import Cookies from "js-cookie";
import { createScreen } from "../hooks/createScreen";
import InventoryController from "../controllers/InventoryController";
import { drawPicker } from "../popovers/Picker";
import { getReportTemplate } from "../data_structures/ReportTemplates";
import Nav from "../ui/Nav";
import { useTabs } from "../hooks/useTabs";
import { getSignal } from "../App";
import dayjs from "dayjs";
import InvoicesBetween from "./report_filters/InvoicesBetween";
import InventoryBetween from "./report_filters/InventoryBetween";
import SalesIn from "./report_filters/SalesIn";
import { FILTER } from "../utils/Struct";
import Spin from "../ui/Spin";
import { useClickAway } from "../hooks/useClickAway";
export default function ReportsCustomInventory2(props) {
    const { controller = "", route = "", signal = {} } = props;


    const row_key = "report_id";
    const [align, setAlign] = useState("start");
    const [loading, setLoading] = useState(false);
    const [loadingPrompt, setLoadingPrompt] = useState(false);
    const [filters, setFilters] = useState({ limit: 40, sort: "updated", group: "" });
    const [selected, setSelected] = useState({})
    const [edit, setEdit] = useState(false);
    const [scope, setScope] = useState(edit?.scope_type);
    const buffer = 20;
    const [autoSave, setAutoSave] = useState(false);
    const [reloadPreview, setReloadPreview] = useState(false);
    const [groups, setGroups] = useState([])
    const [columnView, setColumnView] = useState((Cookies.get("report_column_view") === "true") ? true : false);

    useEffect(() => setEdit(selected), [selected]);


















    const sales_period_between = edit?.filters?.find(item => item.type === -5);
    const sales_types = edit?.filters?.find(item => item.type === -7);
    const sales_types_string = sales_types?.value_1 || "S|F|T";

    const _date_from = (sales_period_between?.value_1) ? dayjs(sales_period_between?.value_1).unix() : "";
    const _date_from_time = (sales_period_between?.value_1 && sales_period_between?.value_1.includes(" ")) ? dayjs(sales_period_between?.value_1).valueOf() : "";
    const _date_to = (sales_period_between?.value_2) ? dayjs(sales_period_between?.value_2).unix() : "";
    const _date_to_time = (sales_period_between?.value_2 && sales_period_between?.value_2.includes(" ")) ? dayjs(sales_period_between?.value_2).valueOf() : "";

    // If the struct has no clerk, treat as new
    const is_new = (edit?.clerk === "");



    const defaultTabs = [
        { set: "edit", label: "name", key: "name", value: edit?.name || "New Report" },
        { set: "edit", label: "group", key: "group", value: edit?.group || "Default" },
        { set: "scope", label: "scope_type", key: "scope_type", value: edit?.scope_type || 1 },
        { set: "scope", label: "sales_in", key: "sales_in", value: _date_from },
        { set: "scope", label: "invoices_between", key: "invoices_between", value: _date_from },
        { set: "scope", label: "inventory_between", key: "inventory_between", value: _date_from },
        { set: "scope", label: "sales_types", key: "sales_types", value: sales_types_string },
        { set: "filters", label: "filter_none", key: "filter_none", value: "" },
        { set: "filters", label: "filter_one", key: "filter_one", value: "" },
        { set: "filters", label: "filter_all", key: "filter_all", value: "" },
        { set: "index", label: "order_1", key: "order_1", value: edit?.order_1 || 0 },
        { set: "index", label: "order_2", key: "order_2", value: edit?.order_2 || 0 },
        { set: "index", label: "order_3", key: "order_3", value: edit?.order_3 || 0 },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, (is_new) ? "name" : "");



    const editing = (index === "") ? false : true;



    const filter_clickaway = useClickAway(() => {
        if (window.bm_state.value === ROUTES.REPORTS.FILTER) {
            setIndex("");
        }
    }, (["filter_all", "filter_one", "filter_none"].includes(index)))


    const filter_clickaway2 = useClickAway(() => {
        if (window.bm_state.value === ROUTES.REPORTS.CUSTOM_EDIT) {

            if (is_new) {
                //callback(false);
            } else {
                addReport()
                //setIndex("");
            }

        }
    }, (["name", "group"].includes(index)))

    const filter_clickaway3 = useClickAway(() => {
        if (window.bm_state.value === ROUTES.REPORTS.COLUMNS) {
            setIndex("");
        }
    }, (["columns"].includes(index)))


    useEffect(() => {
        if (editing) {
            if (window.bm_state.value === route) {
                window.bm_state.value = ROUTES.REPORTS.CUSTOM_EDIT;
            }

        } else {

            window.bm_state.value = route;
            // setIndex("");
            if (selected?.report_id) {
                // refresh? 
                let _f = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
                if (_f > -1) {

                    setSelected({ ...data[_f] });
                }
            } else {
                if (data.length > 0) {
                    setSelected(data[0]);
                } else {
                    setSelected({});
                }

            }
        }
    }, [editing])




    useEffect(() => {

        let _d = [...data];
        let _f = data.findIndex(item => item.report_id === selected?.report_id);
        if (_f > -1) {
            _d[_f] = { ...selected };
            setData(_d);
        }

    }, [selected])


    useEffect(() => {
        const updatedTabs = [...tabs];

        const scope2Items = [
            { set: "scope", label: "sales_in", key: "sales_in", value: _date_from },
            { set: "scope", label: "sales_types", key: "sales_types", value: sales_types_string },
        ];

        const scope3Items = [
            { set: "scope", label: "invoices_between", key: "invoices_between", value: _date_from },
            { set: "scope", label: "sales_types", key: "sales_types", value: sales_types_string },
        ];

        const scope4Items = [
            { set: "scope", label: "inventory_between", key: "inventory_between", value: _date_from },
        ];

        const filtered = updatedTabs.filter(
            t => !["sales_in", "invoices_between", "inventory_between", "sales_types"].includes(t.key)
        );

        const scopeTypeIndex = filtered.findIndex(t => t.key === "scope_type");
        const filterNoneIndex = filtered.findIndex(t => t.key === "filter_none");
        const insertIndex = filterNoneIndex !== -1 ? filterNoneIndex : scopeTypeIndex + 1;


        let newTabs = filtered;
        if (scope === 2) {
            newTabs.splice(insertIndex, 0, ...scope2Items);
        } else if (scope === 3) {
            newTabs.splice(insertIndex, 0, ...scope3Items);
        } else if (scope === 4) {
            newTabs.splice(insertIndex, 0, ...scope4Items);
        }

        setTabs(newTabs);
    }, [scope, _date_from, sales_types_string]);


    // useEffect(() => {

    //     if(!view && index){
    //         setView(index)
    //     }
    //     if(!index && view){
    //         setView("")
    //     }

    // }, [view, index])


    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => current?.[key], obj);
    };

    useEffect(() => {
        if (edit) {
            defaultTabs.forEach(({ key }) => {
                if (key.includes('skip')) return;
                const value = getNestedValue(edit, key);
                update(key, value);
            });
        }
    }, [edit]);



    const nav = [
        { key: KBD.ESCAPE, type: "back", text: "Back", action: () => { props.switchView("reports") } },
        { text: "", type: "shim" },
        { key: KBD.D, text: "Del", action: () => { removeReport() } },
        { key: KBD.E, text: "Edt", action: () => { setIndex("name") } },
        { key: KBD.S, text: "Scope", action: () => { setIndex("scope_type") } },
        { key: KBD.C, text: "Columns", action: () => { setIndex("columns") } },
        { key: KBD.F, text: "Filt", action: () => { setIndex("filter_none") } },
        { key: KBD.G, text: "Grp", action: () => { pickGroup(filters?.group) } },
        { key: KBD.I, text: "Indx", action: () => { setIndex("order_1") } },
        { key: KBD.K, text: "Kopy", action: () => { (selected?.[row_key]) ? copyReport() : showError({ error: "No report selected" }) } },
        { key: KBD.N, text: "New", action: () => createFromTemplate() },
        { key: KBD.U, text: "Update", action: () => (selected?.[row_key]) ? updateReport() : showError({ error: "No report selected" }) },
        { key: KBD.T, text: "Tsv", action: () => (selected?.[row_key]) ? exportReport() : showError({ error: "No report selected" }) },
        { key: KBD.V, text: "View", action: () => (selected?.[row_key]) ? viewReport() : showError({ error: "No report selected" }) },
        { key: KBD.PAGE_DOWN, action: () => (selected?.[row_key]) ? viewReport() : showError({ error: "No report selected" }) },
        { key: KBD.X, text: "Xlsx", action: () => (selected?.[row_key]) ? exportReport(true) : showError({ error: "No report selected" }) },
    ]

    const filters_nav = [
        { key: KBD.ESCAPE, type: "back", text: "Back", action: () => { props.switchView("reports") } },
        { key: KBD.PAGE_DOWN, type: "save", text: "Save", action: () => {  } },
        { text: "", type: "shim" },
        { key: KBD.N, text: "New", action: () => kbdEvent(KBD.N) },
        { key: KBD.E, text: "Edit", action: () => kbdEvent(KBD.E) },
        { key: KBD.D, text: "Delete", action: () => kbdEvent(KBD.R) }
    ]







    function updateRow(_row) {
        let _d = [...data];
        let _f = _d.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {
            _d[_f] = _row;
            setData(_d);
        }
    }


    const viewReport = (async = true, expand = (Cookies.get("report_column_view") === "") ? false : true) => {
        if (!selected?.[row_key]) return;
        const _route = window.bm_state.value;
        if (selected?.cached_row_total === null) {
            showConfirm({
                controller : controller,
                route: route,
                description: <div style={{ "textAlign": "center" }}>Update this report?</div>,
                title: "Report is empty",
                callback: (e) => {
                    if (e) {
                        updateReport(async);
                    }
                }
            })
            return;
        }
        window.bm_state.value = ROUTES.INVENTORY.INVENTORY;
        createScreen({
            is_modal: true,
            signal: signal,
            component: <InventoryController is_modal={selected} expand={expand} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = _route;
            }
        });
    }


    const updateReport = (async = true) => {
        if (!selected?.[row_key]) return;
        setLoading(true);
        setLoadingPrompt(true)
        pubCall("report.updateReport", { report_id: selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
                setSelected(_r);
                if (edit) {
                    setEdit(_r);
                }
                if (async && window.bm_state.value !== route) {
                    showMessage(<>Report: <strong><em>{_r.name}</em></strong><br />has been completed in the background.</>, 10000, "pinned")
                } else {
                    kbdEvent(KBD.V);
                    showMessage("Report completed.")
                }
            } else {
                showError(_r)
            }
            setLoadingPrompt(false)
            setLoading(false);
        })
    }

    const exportReport = (_xlsx = false) => {
        if (!selected?.[row_key]) return;
        let _api = "report.exportReportToTsv"
        let _file_type = ".tsv (tab separated values)";
        if (_xlsx) {
            _api = "report.exportReportToXlsx"
            _file_type = ".xlsx (Excel document)";
        }
        setLoading(true)
        setLoadingPrompt(true)
        let _name = selected?.name || "";
        pubCall(_api, { report_id: selected?.[row_key], want_header: true }, (_s, _r) => {
            if (_s) {
                buildFileFromChunks(_r, pubCall, setLoading, () => {
                    if (window.bm_state.value !== route) {
                        showMessage(<>File: <strong><em>{_name}{_file_type}</em></strong><br />has been downloaded in the background.</>, 10000, "pinned")
                    } else {
                        showMessage("File created successfully.")
                    }
                })
            } else {
                showError(_r)
            }
            setLoading(false);
            setLoadingPrompt(false);
        })
    }


    const createFromTemplate = (_grp = "") => {
        drawPicker({
            controller : controller,
            title: "Create from template", closeable: true, height: 300, ref: null, route: route, callback: (e) => {
                if (e) {
                    createReport(false, getReportTemplate(e, filters.group));
                }
            }, offset: [0, 10],
            options: ENUMS.REPORT_TEMPLATES
        })
    }

    const createReport = (_report = false, _template = {}) => {
        let _new_report = { ..._template };
        // New
        if (!_report) {
            if (!_new_report?.group) {
                _new_report.group = "Default";
            }
            setSelected(_new_report);
            setIndex("name")



            return;
        } else {
            // Copy
            _new_report = _report;
            _new_report.report_id = "";
            pubCall("report.addReport", { new_report: _new_report }, (_s, _r) => {
                setLoading(false)
                if (_s) {
                    setEdit(_r);
                    setSelected(_r);
                } else {
                    showError(_r);
                }
            })
        }
    }


    const copyReport = () => {
        if (!selected?.[row_key]) return;
        createReport(false, { ...selected, "name": "Copy of " + selected.name, "clerk": "", report_id: "" });
    }


    const cycleIndex = () => {
        let _obj = cycleArray(ENUMS.REPORT_SORT_FILTER, "value", filters?.sort);
        setFilters({ ...filters, "sort": _obj.value });
    }

    const removeReport = () => {




        if (!selected?.[row_key]) { return; }
        showConfirm({
            controller : controller,
            route: route,
            title: "Delete report?",
            callback: (e) => {
                if (e) {
                    setLoading(true);
                    pubCall("report.removeReport", { report_id: selected?.[row_key] }, (_s, _r) => {
                        if (_s) {
                            let _f = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
                            if (data.length > _f + 1) {
                                setSelected(data[_f + 1]);
                            }
                            else if (data.length > 0) {
                                setSelected(data[_f - 1]);
                            }
                            else { setSelected({}) }
                            setData(data.filter(item => item?.[row_key] !== selected?.[row_key]));
                            fetchGroups();
                        } else {
                            showError(_r);
                        }
                        setLoading(false)
                    })

                }
            }
        })
    }


    const nextRow = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prevRow = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("report.getReportNext", { ...filters, "limit": 20, [row_key]: data[data.length - 1]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("report.getReportPrevious", { ...filters, "limit": 20, [row_key]: data[0]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const [data, setData] = useState([]);


    const fetchGroups = () => {
        pubCall("report.getReportGroupCounts", {}, (_s, _r) => {
            if (_s) {
                setGroups(_r);
            }
        })
    }

    useEffect(fetchGroups, [])


    const columns = [

        {
            key: "group", align: "left", title: <>Group</>, width: 70, grow: false, render: (e) => {
                return e;
            }
        },

        {
            key: "clerk", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "clerk" }); } }, align: "left", title: <>CL</>, width: 40, grow: false
        },
        {
            key: "date_changed", colSort: { current: (filters.sort === "updated") ? "date_changed" : "", callback: (e) => { setFilters({ ...filters, "sort": "updated" }); } }, align: "left", title: <>Updated</>, width: 100, grow: false, render: (e) => {
                return bm_date(e)
            }
        },
        { key: "name", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "name" }); } }, align: "left", title: <>Name</>, width: 170, grow: true, shrink: true },
        {
            key: "cached_row_total", align: "left", title: <>Items</>, width: 110, grow: false, render: (e) => {
                return (e || e === 0) ? <span style={{ color: "var(--text-green)" }}>{e}</span> : <span style={{ color: "var(--text-red)" }}>Not run</span>
            }
        },
        {
            key: "type", align: "left", title: <>Scope</>, width: 170, grow: false, render: (e) => {
                return getEnumLabel(ENUMS.REPORTS_SCOPE, e);
            }
        }
    ]

    // Keyboard Controls
    useEffect(() => {

        //window.bm_state.value = route;

        const cleanup = listen(controller, route, nav, false, [KBD.ENTER, KBD.ESCAPE]);
        return cleanup;
    }, [selected]);


    useEffect(() => {



        let actions = [
            { key: KBD.ESCAPE, action: (e) => { setIndex("") } },
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            { key: KBD.PAGE_DOWN, action: (e) => { if (index) { addReport() } } },

        ];
        const cleanup = listen(controller, ROUTES.REPORTS.CUSTOM_EDIT, actions, false, [KBD.ESCAPE, KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_DOWN]);
        return cleanup;
    }, [index, tabs]);


    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

    }, [index])


    // Fetch reports
    const fetch = (_id = "", _group = false) => {

        if (_group === "Default") {
            _group = "";
        }
        if (loading) { return }
        setLoading(true);
        let _filters = { ...filters }
        if (_group !== false) {
            _filters.group = _group;

            setFilters({ ...filters, "group": _group })
        }
        if (_id) { _filters.report_id = _id; }
        pubCall("report.getReportInitial", _filters, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }



                setData(_r.rows_previous.concat(_r.rows_next));
                if (_id) {
                    let _f = _r.rows_previous.find(item => item.report_id === _id);
                    if (_f) {
                        setSelected(_f);
                    } else {
                        setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                    }
                } else {
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                }

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);


    const addReport = (_vals = {}, exit = true, index = "") => {


        let _group = getVal("group") || "";

        requestClerkCode({
            bypass: (selected?.clerk) ? selected.clerk : "",
            signal: { value: getSignal() },
            route: route, callback: (e) => {

                if (!e) {
                    return;
                }

                const { scope_type = 1, group = "" } = _vals;



                let _obj = {
                    name: getVal("name"),
                    type: 1,
                    scope_type: scope_type,
                    group: _group,
                    order_1: edit.order_1,
                    order_2: edit.order_2,
                    order_3: edit.order_3,
                    columns: (is_new) ? edit.columns : [],
                    cached_row_total: null,
                    date_changed: dayjs().unix(),
                    filters: edit.filters,
                    clerk: e,
                    report_id: edit?.[row_key] || "",
                }
                let _update = (_obj?.[row_key]) ? { report_id: _obj?.[row_key], report_info: _obj } : { new_report: _obj }




                pubCall((is_new) ? "report.addReport" : "report.editReport", _update, (_s, _r) => {
                    if (_s) {

                        fetch(_r?.report_id, _group);
                        if (exit) {
                            setIndex("")
                        }
                        setReloadPreview(!reloadPreview);
                        fetchGroups();


                    } else {
                        showError(_r);
                    }
                })

            }
        })

    }


    const drawGroups = (_value) => {

        refs.current[index].blur();
        drawPicker({
            controller : controller,
            value: _value, title: "Select Group", closeable: true, height: 300, ref: refs.current[index], route: route, close: () => { refs.current[index].focus(); }, callback: (e) => {
                if (e) {
                    update("group", e)
                }
                refs.current[index].focus();
            }, offset: [0, 10],
            options: groups.map(item => {
                return {
                    label: item.name,
                    value: item.name
                }
            })
        })
    }

    const pickGroup = (_value) => {

        if (index) { return; }
        drawPicker({
            controller : controller,
            value: _value, title: "Select Group", closeable: true, height: 300, route: route, close: () => { }, callback: (e) => {
                if (e) {
                    setFilters({ ...filters, "group": e });
                    fetch("", e);
                }
            }, offset: [0, 10],
            options: groups.map(item => {
                return {
                    label: <Space><div style={{ "borderRight": "1px solid var(--border-secondary)", "width": "30px", "textAlign": "center" }}>{item.count}</div>{item.name}</Space>,
                    value: item.name
                }
            })
        })
    }

    const filterCallback = (_filters, _direction = "next", _group = "AND") => {
        // TODO deal with filters...
        if (_direction !== "prev") {
            next();
        } else {
            prev();
        }
    }

    const updateOrderBy = (_orderbys) => {

        const { order_1 = getVal("order_1"), order_2 = getVal("order_2"), order_3 = getVal("order_3") } = _orderbys;

        pubCall("report.editOrderBys", { report_id: edit?.[row_key], order_1: order_1, order_2: order_2, order_3: order_3 }, (_s, _r) => {
            if (_s) {
                // reload preview
                setSelected(_r)
            }
        })
    }

    return (<>
        <div className="controller">
            <Spin loading={loading}>
                <div style={{ height: "calc(100vh - 140px)", minHeight: "491px", gap: "15px" }}>
                    <div style={{ display: "flex", width: "100%", gap: "0px" }}>
                        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", "padding": "10px 15px" }}>

                            <div style={{ "flex": 1 }}>





                                <Float>
                                    <Label style={{ "textAlign": "left" }}>Reports</Label>
                                    <div className={(editing) ? "desaturate" : "history_table"} style={{ "fontSize": "14px" }}>Group: <strong><a onClick={() => pickGroup(filters?.group)}>{filters.group || "Default"}</a></strong></div>
                                </Float>

                                <div className="shim" />

                                <VirtualTable
                                    controller={controller}
                                    className={(editing) ? "desaturate disabled-area" : "history_table"}
                                    scrollbar={true}
                                    onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                                    next={nextRow}
                                    prev={prevRow}
                                    align={align}
                                    row_key={row_key}
                                    current={selected}
                                    data={data}
                                    columns={columns}
                                    width={0}
                                    height={220}
                                    loading={loading}
                                    offset={520}
                                    route={route}
                                />

                                <div className="shim" />
                                <Divider />
                                <div className="shim" />

                                <Float>

                                    <Space>
                                        <Label width={40}><nobr>Index:</nobr></Label>
                                        <Select
                                            number
                                            {...editProps("order_1")}
                                            offset={[5, 0]}
                                            align="top"
                                            width={154}
                                            autocomplete
                                            top={true}
                                            title="Select Index"
                                            options={ENUMS.REPORTS_INDEX.sort((a, b) => a.label.localeCompare(b.label)).slice(1)}
                                            placeholder="Select index"
                                            returnRoute={ROUTES.REPORTS.CUSTOM_EDIT}
                                            onSelect={(e) => setTimeout(() => { updateOrderBy({ order_1: e }); setIndex("order_2") }, 0)}
                                            onNext={() => { setTimeout(() => { setIndex("order_2") }, 0) }}
                                            onPrev={() => { setTimeout(() => { setIndex("") }, 0) }}
                                            onClick={() => (index !== "order_1") && setIndex("order_1")}
                                        />

                                        <Select
                                            number
                                            {...editProps("order_2")}
                                            //onChange={(val) => setV(val)}
                                            offset={[5, 0]}
                                            align="top"
                                            width={154}
                                            autocomplete
                                            title="Select Index"
                                            options={ENUMS.REPORTS_INDEX.sort((a, b) => a.label.localeCompare(b.label))}
                                            placeholder="Select index..."
                                            returnRoute={ROUTES.REPORTS.CUSTOM_EDIT}
                                            onSelect={(e) => setTimeout(() => { updateOrderBy({ order_2: e }); setIndex("order_3"); }, 0)}
                                            onNext={() => { setTimeout(() => { setIndex("order_3") }, 0) }}
                                            onPrev={() => { setTimeout(() => { setIndex("order_1") }, 0) }}
                                            onClick={() => (index !== "order_2") && setIndex("order_2")}
                                        />

                                        <Select
                                            number
                                            {...editProps("order_3")}
                                            //onChange={(val) => setV(val)}
                                            title="Select Index"
                                            offset={[5, 0]}
                                            align="top"
                                            width={154}
                                            autocomplete
                                            options={ENUMS.REPORTS_INDEX.sort((a, b) => a.label.localeCompare(b.label))}
                                            placeholder="Select index..."
                                            returnRoute={ROUTES.REPORTS.CUSTOM_EDIT}
                                            onSelect={(e) => setTimeout(() => { updateOrderBy({ order_3: e }); setIndex(""); }, 0)}
                                            onNext={() => { setTimeout(() => { setIndex("") }, 0) }}
                                            onPrev={() => { setTimeout(() => { setIndex("order_2") }, 0) }}
                                            onClick={() => (index !== "order_3") && setIndex("order_3")}
                                        />
                                    </Space>
                                    <Label style={{ "textAlign": "left" }}>
                                        {(index !== "columns" && <a onClick={() => setIndex("columns")}>Edit Columns</a>)}
                                        {(index === "columns" && <a onClick={() => setIndex("")}>Done Editing</a>)}
                                    </Label>
                                </Float>
                                <div className="shim" />
                                <div className="shim" />
                            </div>
                            <div style={{ "flex": "1", "height": "100%" }}>
                                {(selected?.columns &&
                                    <ReportColumns
                                        controller={controller}
                                        scope={scope}
                                        is_new={is_new}
                                        columnView={columnView}
                                        reloadTrigger={reloadPreview}
                                        report={selected}
                                        setReport={setEdit}
                                        escape={() => setIndex("")}
                                        route={ROUTES.REPORTS.COLUMNS}
                                        {...editProps("columns")}
                                        edit={index === "columns"}
                                    />
                                )}
                            </div>
                        </div>

                        <div style={{ width: 550, display: "flex", flexDirection: "column", height: "calc(100vh - 140px)", minHeight: "490px", "backgroundColor": "var(--card-bg)", borderLeft: "1px solid var(--border-secondary)", "padding": "10px 15px", "paddingBottom": "0px" }}>
                            <div>

                                <div ref={filter_clickaway2}>
                                    <Space>
                                        <Label style={{ textAlign: "left" }} width={40}>Name</Label>
                                        <Input maxLength={50} {...editProps("name")} width={420} onEnter={() => next()} onClick={() => (index !== "name") && setIndex("name")} />
                                        <Label width={40}>Group</Label>
                                        <Input doubleclick={(e) => drawGroups(e)} onPageUp={(e) => drawGroups(e)} maxLength={20} {...editProps("group")} onEnter={() => addReport()} width={200} onClick={() => (index !== "group") && setIndex("group")} />
                                    </Space>
                                </div>

                                <div className="shim" />
                                <Space size={5} style={{ "alignItems": "end" }}>
                                    <Label width={40}>Scope:</Label>
                                    <Select
                                        {...editProps("scope_type")}
                                        width={170}
                                        offset={[5, 0]}
                                        index={index}
                                        title="Select Scope"
                                        options={ENUMS.REPORTS_SCOPE}
                                        top
                                        placeholder="Select index"
                                        returnRoute={ROUTES.REPORTS.CUSTOM_EDIT}
                                        onSelect={(e) => {


                                            setScope(e);


                                            setTimeout(() => {
                                                let _ind = (e === 2) ? "sales_in" : (e === 3) ? "invoices_between" : (e === 4) ? "inventory_between" : "";
                                                addReport({ scope_type: e }, false, _ind);

                                                switch (e) {
                                                    case 1:
                                                        if (edit.filters.some(f => f.type === -6 || f.type === -5 || f.type === -7)) {
                                                            let _filters = [...edit.filters.filter(item => item.type !== -6 && item.type !== -5 && item.type !== -7)]
                                                            _filters = updateOrdering(_filters);
                                                            pubCall("report.purgeAndReplaceFilters", { report_id: edit?.[row_key], filters_info: _filters}, (_s, _r) => {
                                                                if (!_s) {
                                                                    showError(_r);
                                                                } else {
                                                                    setEdit(_r);
                                                                }
                                                            })
                                                        }
                                                        break;
                                                }


                                            }, 50)

                                        }}
                                        onNext={() => { setTimeout(() => { next() }, 50) }}
                                        onPrev={() => { setTimeout(() => { prev() }, 50) }}
                                        onClick={() => (index !== "scope_type") && setIndex("scope_type")}
                                    />
                                </Space>
                                <div className="shim" />


                                {(getVal("scope_type") === 3 &&
                                    <>
                                        <InvoicesBetween controller={controller} autoKey={3} setAutoSave={setAutoSave} autoSave={autoSave} {...editProps("invoices_between")} goto={(e) => setIndex(e)} setReport={setSelected} escape={() => setIndex("")} report={edit} edit={(index === "invoices_between")} />
                                    </>
                                )}

                                {(getVal("scope_type") === 4 &&
                                    <>
                                        <InventoryBetween autoKey={4} setAutoSave={setAutoSave} autoSave={autoSave} {...editProps("inventory_between")} goto={(e) => setIndex(e)} setReport={setSelected} escape={(e) => { setSelected(e); setIndex("") }} report={edit} edit={(index === "inventory_between")} />
                                        <div className="shim" />
                                    </>
                                )}
                                {(getVal("scope_type") === 2 &&
                                    <>
                                        <SalesIn controller={controller} autoKey={2} setAutoSave={setAutoSave} autoSave={autoSave} {...editProps("sales_in")} goto={(e) => setIndex(e)} setReport={setSelected} escape={() => setIndex("")} report={edit} edit={(index === "sales_in")} />
                                    </>
                                )}

                                {((getVal("scope_type") === 3 || getVal("scope_type") === 2) &&
                                    <>
                                        <div className="shim" />
                                        <Space>
                                            <Label width={40}><nobr>Types:</nobr></Label>

                                            <Tags callback={(_v, _dir) => {
                                                if (_dir === "next") {

                                                    setIndex("");
                                                } else {
                                                    prev();
                                                }

                                            }} onClick={(e, f) => console.log(f)} goto={(e) => (e === "columns") ? setIndex("columns") : setIndex("")} {...editProps("sales_types")} onChange={(_v) => {
                                                let _filters = edit?.filters.filter(item => item.type !== -7 && item.where_type === "AND");
                                                if (_v) {
                                                    _filters.unshift({ ...FILTER, "type": -7, "where_type": "AND", value_1: _v })
                                                }

                                                _filters = updateOrdering(_filters);
                                                pubCall("report.purgeAndReplaceFilters", { report_id: edit?.[row_key], filters_info: _filters }, (_s, _r) => {
                                                    if (!_s) {
                                                        showError(_r);
                                                    } else {
                                                        setEdit(_r)
                                                        //props.refresh(_r)
                                                    }
                                                })
                                            }} edit={(index === "sales_types")} value={sales_types_string} height={24} width={450} items={ENUMS.SALES_TYPES} />
                                        </Space>
                                        <div className="shim" />
                                    </>
                                )}





                                {/* <div className="shim" />
                        <Space>
                            <Label width={40}>From</Label>
                            <Input value="Nov23-25" width={100} />
                            <Input value="00:00" width={100} />
                        </Space>
                        <div className="shim" />
                        <Space>
                            <Label width={40}>To</Label>
                            <Input value="Nov24-25" width={100} />
                            <Input value="23:59" width={100} />
                        </Space>
                        <div className="shim" />
                        <Space>
                            <Label width={40}>Types</Label>
                            <Tags height={24} width={450} items={ENUMS.SALES_TYPES} />

                        </Space>
                        <div className="shim" /> */}


                            </div>
                            <div className="shim" /><div className="shim" /><div className="shim" />
                            <div ref={filter_clickaway} style={{
                                flex: "1",
                                display: "flex",
                                flexDirection: "column",

                                // height: "calc(100vh - 300px)",
                                // minHeight: "450px",
                                gap: "15px"    // or a fixed px height
                            }}>
                                <div style={{ flex: 1 }}>
                                    <ReportFilter controller={controller} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "NOT") || []} show_add route={ROUTES.REPORTS.FILTER} {...editProps("filter_none")} escape={() => { setIndex("") }} report={edit} setReport={setSelected} callback={(e, d) => filterCallback(e, d)} where_type="NOT" header="None of (Exclude)" headerClass="dark-red" showColumnHeaders={false} activate={() => setIndex("filter_none")}  edit={(index === "filter_none")} />
                                </div>
                                <div style={{ flex: 1 }}>

                                    <ReportFilter controller={controller} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "OR") || []} show_add route={ROUTES.REPORTS.FILTER} {...editProps("filter_one")} escape={() => setIndex("")} report={edit} setReport={setSelected} callback={(e, d) => filterCallback(e, d)} where_type="OR" header="One of (Include/Any)" headerClass="dark-orange" showColumnHeaders={false} activate={() => setIndex("filter_one")}  edit={(index === "filter_one")} />
                                </div>
                                <div style={{ flex: 1 }}>

                                    <ReportFilter controller={controller} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "AND") || []} show_add route={ROUTES.REPORTS.FILTER} {...editProps("filter_all")} escape={() => setIndex("")} report={edit} setReport={setSelected} callback={(e, d) => filterCallback(e, d)} where_type="AND" header="All of (Must/All)" headerClass="dark-green" showColumnHeaders={false} activate={() => setIndex("filter_all")} edit={(index === "filter_all")} />
                                </div>
                                <div className="shim" />
                            </div>






                        </div>
                    </div>


                    <Float style={{ "gap": "20px" }}>
                        <div style={{ "width": "100%" }}>


                        </div>

                    </Float>
                </div>

                <div className="shim" />
                <Divider />
                <div style={{ 'height': "30px" }}>
                    <Space style={{ "padding": "0px 15px" }}>
                        {(index === "" && <Nav nav={nav} />)}
                        {(index === "filter_none" || index === "filter_one" || index === "filter_all") && <Nav nav={filters_nav} />}
                    </Space>
                </div>
            </Spin>
        </div>
    </>)
}